import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="extra-items"
export default class extends Controller {
  static targets = ["priceInput"];

  validatePrice(event) {
    const input = event.target;

    const extraItemPriceMax = parseFloat(input.getAttribute('max'));
    const extraItemsPriceMax = parseFloat(input.dataset.extraItemsPriceMax);

    if (extraItemsPriceMax) {
      let sum = 0;
      this.priceInputTargets.forEach((el) => {
        const value = parseFloat(el.value);
        if (!isNaN(value)) sum += value;
      });

      // alert() steals focus; dismissing it re-blurs the input and re-fires this
      // handler. Guard so the over-cap warning is shown only once per breach.
      if (sum > extraItemsPriceMax && !this.overCapWarned) {
        this.overCapWarned = true;
        alert(
          "You can specify items up to $" +
          extraItemPriceMax +
          " each and up to an overall maximum of $" +
          extraItemsPriceMax
        );
      } else if (sum <= extraItemsPriceMax) {
        this.overCapWarned = false;
      }
    }

    return input.reportValidity();
  }
}
